(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.gcs-header');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-gcs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // 1) Reading progress bar
    var bar = document.querySelector('[data-gcs-progress]');
    var article = document.querySelector('.gcs-article__content');
    function onScroll() {
      if (!bar || !article) return;
      var rect = article.getBoundingClientRect();
      var total = rect.height + window.innerHeight * 0.5;
      var seen = Math.min(Math.max(window.innerHeight - rect.top, 0), total);
      var pct = total > 0 ? Math.min(seen / total, 1) : 0;
      bar.style.setProperty('--gcs-scroll', pct.toFixed(3));
      bar.style.transform = 'scaleX(' + pct.toFixed(3) + ')';
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // 2) ToC active link via IntersectionObserver
    var tocLinks = document.querySelectorAll('[data-gcs-toc-link]');
    if (!tocLinks.length) return;

    var linkMap = {};
    tocLinks.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (id) linkMap[id] = a;
    });

    var headings = Array.prototype.filter.call(
      document.querySelectorAll('.gcs-article__content h2[id]'),
      function (h) { return !!linkMap[h.id]; }
    );
    if (!headings.length) return;

    var visible = new Set();
    function setActive(id) {
      tocLinks.forEach(function (a) { a.classList.remove('is-active'); });
      if (id && linkMap[id]) linkMap[id].classList.add('is-active');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.add(e.target.id);
        else visible.delete(e.target.id);
      });
      if (visible.size > 0) {
        var top = null;
        headings.forEach(function (h) {
          if (visible.has(h.id) && (!top || h.getBoundingClientRect().top < top.getBoundingClientRect().top)) {
            top = h;
          }
        });
        if (top) setActive(top.id);
      } else {
        var above = null;
        headings.forEach(function (h) {
          var t = h.getBoundingClientRect().top;
          if (t < 120 && (!above || t > above.getBoundingClientRect().top)) above = h;
        });
        if (above) setActive(above.id);
      }
    }, { rootMargin: '-88px 0px -65% 0px', threshold: [0, 1] });

    headings.forEach(function (h) { io.observe(h); });

    // Smooth scroll for ToC clicks (respects reduced motion)
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    tocLinks.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;
        ev.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 88;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + id);
        setActive(id);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // 1) Reading progress bar
    var bar = document.querySelector('[data-gcs-progress]');
    var article = document.querySelector('.gcs-guide__content');
    function onScroll() {
      if (!bar || !article) return;
      var rect = article.getBoundingClientRect();
      var total = rect.height + window.innerHeight * 0.5;
      var seen = Math.min(Math.max(window.innerHeight - rect.top, 0), total);
      var pct = total > 0 ? Math.min(seen / total, 1) : 0;
      bar.style.setProperty('--gcs-scroll', pct.toFixed(3));
      bar.style.transform = 'scaleX(' + pct.toFixed(3) + ')';
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // 2) ToC active link via IntersectionObserver
    var tocLinks = document.querySelectorAll('[data-gcs-toc-link]');
    if (!tocLinks.length) return;

    var linkMap = {};
    tocLinks.forEach(function (a) {
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (id) linkMap[id] = a;
    });

    var headings = Array.prototype.filter.call(
      document.querySelectorAll('.gcs-guide__content h2[id]'),
      function (h) { return !!linkMap[h.id]; }
    );
    if (!headings.length) return;

    var visible = new Set();
    function setActive(id) {
      tocLinks.forEach(function (a) { a.classList.remove('is-active'); });
      if (id && linkMap[id]) linkMap[id].classList.add('is-active');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.add(e.target.id);
        else visible.delete(e.target.id);
      });
      if (visible.size > 0) {
        // pick the topmost visible heading
        var top = null;
        headings.forEach(function (h) {
          if (visible.has(h.id) && (!top || h.getBoundingClientRect().top < top.getBoundingClientRect().top)) {
            top = h;
          }
        });
        if (top) setActive(top.id);
      } else {
        // fall back: closest above viewport
        var above = null;
        headings.forEach(function (h) {
          var t = h.getBoundingClientRect().top;
          if (t < 120 && (!above || t > above.getBoundingClientRect().top)) above = h;
        });
        if (above) setActive(above.id);
      }
    }, { rootMargin: '-88px 0px -65% 0px', threshold: [0, 1] });

    headings.forEach(function (h) { io.observe(h); });

    // Smooth scroll for ToC clicks (respects reduced motion)
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    tocLinks.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;
        ev.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 88;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        history.replaceState(null, '', '#' + id);
        setActive(id);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
